import styled from "styled-components";

export const Link = styled.a<{
  disabled?: boolean;
  underline?: boolean;
}>`
  color: #2196f3;
  text-decoration: ${(props) => (props.underline ? "underline" : "none")};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  font-size: 14px;
  font-weight: 500;
  transition: color 0.2s ease;
  border: none;
  background: none;
  padding: 0;
  margin: 0;

  &:hover {
    ${(props) =>
      !props.disabled &&
      `
      color: #1976d2;
      text-decoration: underline;
    `}
  }

  &:visited {
    color: #2196f3;
  }
`;
